import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { ActionConfirmModal } from './action-confirm-modal';
import { ActionConfirmModalComponent } from './action-confirm-modal.component';
import { ModalRole } from './modal-role.enum';

@Injectable()
export class ActionConfirmModalService {
  constructor(private matDialog: MatDialog) { }

  modalConfig: MatDialogConfig = {
    minWidth: '25%',
    maxWidth: '50%',
    minHeight: '50%'
  };

  dangerModal(data: ActionConfirmModal) {
    data = { ...data, role: ModalRole.MODAL_DANGER };

    return this.matDialog.open(ActionConfirmModalComponent, {
      data,
      ...this.modalConfig
    });
  }
  warnModal(data: ActionConfirmModal) {
    data = { ...data, role: ModalRole.MODAL_WARN };
    return this.matDialog.open(ActionConfirmModalComponent, {
      data,
      ...this.modalConfig
    });
  }
  infoModal(data: ActionConfirmModal) {
    data = {
      ...data, role: ModalRole.MODAL_INFO, hideCancelButton: true
    };
    return this.matDialog.open(ActionConfirmModalComponent, {
      data,
      ...this.modalConfig
    });
  }
}
